import React, { useState } from "react";

// third-party
import { Link } from "react-router-dom";
import Avatar from "react-avatar";
import { useSelector } from "react-redux";

// project-import
import {
  GoogleAnalyticsEnum,
  triggerFunction,
} from "../../utils/google-analytics";
import StarRating from "../star-rating/StarRating";
import ModalLogin from "../form/ModalLogin";
import { useCoursesContext } from "../../context/courses_context";
import { getOrCreateGuestId, slugify } from "../../utils";
import { SupportUsForm } from "./SupportUsForm";
import ToolTip from "../../common/Tooltip/ToolTip";
import Image from "../../common/footer/Images/Image";
import { formatViews, numberFormatter } from "../../utils/course";

const CourseTwo = ({ data, classes, coursesDomain }) => {

  // State variables
  const [isLoggedOut, setIsLoggedOut] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // Extracting methods and variables from context
  const { updateCourseLikes, coursesLoading } = useCoursesContext();

  // Reading data from store
  const { loginData } = useSelector((item) => item.user);
  const instructorData = useSelector(
    (state) => state.instructor.instructorData
  );

  // Constant variables
  const indexOfInstructor =
    instructorData &&
    instructorData.length &&
    instructorData.findIndex(function (instructor) {
      return instructor.id === data.instructorId;
    });
  const courseTitleForAnalytics =
    GoogleAnalyticsEnum.SF_COURSE_CLICKED + "_" + data.title;
  const instructorThumb =
    instructorData &&
    instructorData[indexOfInstructor] &&
    instructorData[indexOfInstructor] &&
    instructorData[indexOfInstructor].image;
  const instructorId =
    instructorData &&
    instructorData[indexOfInstructor] &&
    instructorData[indexOfInstructor].id;
  const instructorName =
    instructorData &&
    instructorData[indexOfInstructor] &&
    instructorData[indexOfInstructor].name;
  const member = (loginData && loginData.data) || null;
  const currentUserId = member ? member.userRecordId || "" : getOrCreateGuestId();

  // Local variables
  let isLiked = false;
  let totalLikes = 0;

  if (!coursesLoading && data) {
    (data ? data.likes || [] : []).forEach((item) => {
      if (item.userId === currentUserId && item.isLiked) {
        isLiked = true;
      }

      if (item.userId) {
        totalLikes += item.count;
      }
    });
  }

  // Constant function
  const handleLikeBtnClick = (value) => {
    try {
      // if (!member) {
      //   return openModalLogin();
      // }
      let likes = [...(data?.likes || [])];
      const index = likes.findIndex((item) => item.userId === currentUserId);
      if (index !== -1) {
        likes = likes.map((like, i) =>
          i === index ? { ...like, count: value ? 1 : 0, isLiked: value } : like
        );
      } else {
        likes.push({
          userId: currentUserId,
          count: value ? 1 : 0,
          isLiked: value,
          idValue: data ? data?.id : "",
          id: data ? data?.id : "",
        });
      }

      if (likes && likes.length) {
        updateCourseLikes(data ? data?.id : "", likes);
        triggerFunction(window.location.pathname + " " + GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_SALESFORCE_COURSE_LIKE_ADDED);
      }
    } catch (error) {
      console.error("105 : CourseTypeTwo : Error while updating likes :", error && JSON.stringify(error));
      throw error;
    }
  };

  const openModalLogin = () => setIsLoggedOut(true);
  const closeModalLogin = () => setIsLoggedOut(false);

  const onClickSupportForm = () => {
    triggerFunction(window.location.href + GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_SUPPORT_FORM_VIEW);
    setShowModal(true);
  }

  const onCloseSupportForm = () => {
    triggerFunction(window.location.href + GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_SUPPORT_FORM_CLOSE);
    setShowModal(false);
  }

  const formattedViews = formatViews(data.quizzes || 0, { decimalPlaces: 2 });

  return (
    <div
      className={`edu-card card-type-2 radius-small ${classes ? classes : ""}`}
    >
      <div className="inner">
        <div className="thumbnail">
          <div className="w-100 ratio ratio-16x9 h-100">
            <Link
              to={
                process.env.PUBLIC_URL +
                `/course-details/${slugify(data?.link)}`
              }
            >
              <Image src={data?.image} alt="featured" fill />
            </Link>
          </div>
          <div className="top-position status-group left-top">
            <span className="eduvibe-status status-02">
              <i className="icon-time-line"></i> {data.durationInHourMinute}
            </span>
          </div>
          <div className="wishlist-top-right">
            <button className="eduvibe-status status-07 border-0" onClick={() => handleLikeBtnClick(!isLiked)}>
              <i className={`icon-Heart ${isLiked ? "text-danger" : ""}`}></i> {numberFormatter.format(totalLikes)}
            </button>
            {/* <button className="wishlist-btn-count" onClick={() => handleLikeBtnClick(!isLiked)}><i className={`icon-Heart ${isLiked ? "text-danger" : ""}`}></i> {totalLikes}</button> */}
          </div>
        </div>
        <div className="content">
          {/* <div className="row card-top">
            <div className="cl-lg-12 d-flex justify-content-start author-meta">
              <div className="author-thumb">
                {instructorName && instructorThumb && instructorId ? (
                  <Link
                    to={
                      process.env.PUBLIC_URL +
                      `/instructor-details/${instructorId}`
                    }
                  >
                    <Avatar
                      className="custom-avatar object-fit-cover"
                      size={34}
                      round={true}
                      src={
                        instructorThumb
                          ? `${process.env.PUBLIC_URL}/images/instructor/${instructorThumb}`
                          : ""
                      }
                    />
                    <span className="author-title">
                      {instructorName}
                    </span>
                  </Link>
                ) : (
                  <Link to="#">
                    <Avatar
                      className="custom-avatar"
                      name={"No Instructor"}
                      size={34}
                      round={true}
                      src=""
                      color="#525FE1"
                    />
                    <span className="author-title">No Instructor</span>
                  </Link>
                )}
              </div>
            </div>
            <div className="col-lg-12 d-flex justify-content-center edu-rating rating-default">
              <StarRating data={data} />
            </div>
          </div> */}
          <div className="container">
            <div className="row align-items-center justify-content-center my-2">
              {/* Instructor Section */}
              <div className="col-auto">
                {instructorName && instructorId ? (
                  <Link to={`${process.env.PUBLIC_URL}/instructor-details/${instructorId}`}>
                    <Avatar
                      className="custom-avatar object-fit-cover"
                      size={34}
                      round={true}
                      alt={`Longswitch Academy Instructor ${instructorName}`}
                      src={instructorThumb ? `${process.env.PUBLIC_URL}/images/instructor/shubham-prajapati-longswitch-instructor-avatar.jpg` : ''}
                    />
                    <span className="author-title">{instructorName}</span>
                  </Link>
                ) : (
                  <Link to="#">
                    <Avatar className="custom-avatar" name={"No Instructor"} size={34} round={true} src="" color="#525FE1" />
                    <span className="author-title">No Instructor</span>
                  </Link>
                )}
              </div>
              {/* Lesson Count */}
              <div className="col-auto edu-rating rating-default">
                <StarRating data={data} />
              </div>
            </div>

          </div>
          <h6 className="title text-truncate">
            <ToolTip title={data.title} id={'course-title'}>
              {/* <Link
                to={
                  process.env.PUBLIC_URL +
                  `/${coursesDomain}/course-details/${slugify(data?.link)}`
                }
                dangerouslySetInnerHTML={{ __html: data.title }}
                onClick={() =>
                  triggerFunction(GoogleAnalyticsEnum.BUTTON, courseTitleForAnalytics)
                }
              ></Link> */}

              <Link
                to={
                  process.env.PUBLIC_URL +
                  `/course-details/${slugify(data?.link)}`
                }
                dangerouslySetInnerHTML={{ __html: data.title }}
                onClick={() =>
                  triggerFunction(GoogleAnalyticsEnum.BUTTON, courseTitleForAnalytics)
                }
              ></Link>
            </ToolTip>
          </h6>
          <ul className="edu-meta meta-01 align-items-center justify-content-center">
            <li>
              <i className="icon-eye-line"></i>
              {data.quizzes > 1 ? formattedViews : formattedViews}
            </li>
            <li className="text-end">
              <i className="icon-file-list-4-line"></i>
              {data.lesson} Lessons
            </li>
          </ul>
          <div className="row align-items-center my-1 sm-my-5 gy-3">
            <div className="col-12 col-sm-6">
              <div className="price-list price-style-01">
                {data?.price && data?.price !== "00.00" && data?.price !== "0.00" ? (
                  <span className="price text-success fw-bold">${data?.price} USD</span>
                ) : (
                  <span className="price text-success fw-bold">Free</span>
                )}
                {/* <div> */}
                {/* {data.price === '00.00' ? (
                                        <span className="price text-success fw-bold">Free</span>
                                    ) : ( */}
                {/* <span className="price text-dark fw-bold">${data.price}</span> */}
                {/* )}*/}
                {(data.oldPrice !== "00.00" || data.oldPrice !== "0.00") && (
                  <span className="price text-muted text-decoration-line-through ms-2 text-xl">${data.oldPrice}</span>
                )}
                {/* </div> */}
              </div>
            </div>
            <div className="col-12 col-sm-6 sm-text-end">
              <div className="price-list price-style-01">
                {/* <button className="edu-btn btn-small" onClick={onClickSupportForm}>
                  <ToolTip title={"Support Us"} id={"support"}>
                    Support Us
                  </ToolTip>
                </button> */}
                <a href={data?.videoLink[0]} target="blank" className="edu-btn btn-small btn-white-secondary px-3">
                  <ToolTip title={"Watch now on YouTube"} id={"watch-now"}>
                    <i className="icon-youtube p-0"></i>
                  </ToolTip>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalLogin show={isLoggedOut} onCloseModalLogin={closeModalLogin} title={'Login to like the Course'} />
      <SupportUsForm show={showModal} onCloseModal={onCloseSupportForm} title={"Support Us"} />
    </div>
  );
};
export default CourseTwo;
